import React from 'react';
import styles from './Step.module.less';

const Step4 = () => (
  <div className={styles.stepContainer}>
    <p className={styles.dek}>
      You can also <strong>text or email any guest</strong> a unique link to fill out a custom form.
    </p>
    <video muted playsInline autoPlay preload="auto" loop>
      <source
        src="https://d1tntvpcrzvon2.cloudfront.net/static-assets/videos/guest-list-animations/Collect-Text.mp4"
        type="video/mp4"
      />
      Sorry, your browser doesn&apos;t support embedded videos.
    </video>
  </div>
);

export default Step4;



// WEBPACK FOOTER //
// ./src/pages/TourSteps/Step4.jsx